import React from "react";
// import { RiskLevel } from "../../../graphql/types";
import { Colors } from "../colors";
import styles from "./gross-profit-margin.css";
import { GpmThreshold } from "../../data-types";

const { ["container"]: containerClassName } = styles;

type Props = {
  gpm: number;
  gpmThreshold: GpmThreshold;
};

// const riskColorMap = new Map<RiskLevel, string>([
//   [RiskLevel.LowRisk, Colors.Success],
//   [RiskLevel.MediumRisk, Colors.Warning],
//   [RiskLevel.HighRisk, Colors.Error],
// ]);

const statusColors = {
  red: Colors.Error,
  amber: Colors.Warning,
  green: Colors.Success,
};

function getLabelColour(value: number, threshold: GpmThreshold | null): "red" | "amber" | "green" {
  if (threshold === null) {
    return "green";
  } else if (threshold.gpmWarningThreshold) {
    // amber percent is a percentage of the gpmTarget. e.g. if target is 70% and warning threshold is 10% then amberPercent is 7%.
    const amberPercent = (threshold.gpmWarningThreshold * threshold.gpmDangerThreshold) / 100;
    const redPercent = threshold.gpmDangerThreshold - amberPercent;
    return value < redPercent ? "red" : value < redPercent + amberPercent ? "amber" : "green";
  } else {
    return value >= threshold.gpmDangerThreshold ? "green" : "amber";
  }
}

export const GrossProfitMargin: React.FC<Props> = ({ gpm, gpmThreshold }) => {
  return (
    <div className={containerClassName}>
      <div>
        Actual GPM :{" "}
        <span
          style={{
            color: statusColors[getLabelColour(gpm, gpmThreshold)],
          }}
        >
          {Math.round(gpm)}%
        </span>
      </div>
    </div>
  );
};
